module.exports = __webpack_public_path__ + "static/media/ios-hand.a888e451.svg";